(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeroSlides() {
    document.querySelectorAll('[data-mt-hero-slides]').forEach(function (root) {
      var slides = root.querySelectorAll('.mt-hero__slide');
      if (slides.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      var ms = parseInt(root.getAttribute('data-mt-intervalo'), 10) || 3000;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, ms);
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-mt-producto]');
    if (!root) return;

    var principal = root.querySelector('[data-mt-principal]');
    root.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (principal) {
          principal.src = btn.getAttribute('data-src');
          principal.alt = btn.getAttribute('data-alt') || '';
        }
        root.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
        btn.classList.add('is-activa');
      });
    });

    var dataEl = root.querySelector('[data-mt-variantes]');
    var form = root.querySelector('form');
    var idInput = root.querySelector('[data-mt-id]');
    var precio = root.querySelector('[data-mt-precio]');
    var boton = root.querySelector('[data-mt-boton]');
    var variantes = [];
    try { variantes = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}

    function actualizarVariante() {
      if (!variantes.length) return;
      var elegidas = [];
      root.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        elegidas.push(c ? c.value : null);
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === elegidas[i]; });
      });
      if (!v) {
        if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-no-disp'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (precio) {
        precio.innerHTML = '<span>' + v.price_fmt + '</span>' + (v.compare_fmt ? '<s>' + v.compare_fmt + '</s>' : '');
      }
      if (boton) {
        boton.disabled = !v.available;
        boton.textContent = v.available ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
      }
      if (v.image) {
        var m = root.querySelector('[data-mt-mini][data-src="' + v.image + '"]');
        if (m) m.click();
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      }
    }
    root.querySelectorAll('[data-mt-opcion] input').forEach(function (i) {
      i.addEventListener('change', actualizarVariante);
    });

    var qty = root.querySelector('[data-mt-qty]');
    root.querySelectorAll('[data-mt-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = parseInt(qty.value, 10) || 1;
        n += parseInt(b.getAttribute('data-mt-qty-btn'), 10);
        qty.value = Math.max(1, n);
      });
    });

    if (form && boton) {
      var msg = root.querySelector('[data-mt-mensaje]');
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (boton.disabled) return;
        var original = boton.textContent;
        boton.disabled = true;
        boton.textContent = boton.getAttribute('data-anadiendo');
        var body = new FormData(form);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'error');
            if (msg) { msg.className = 'mt-pp__mensaje'; msg.textContent = boton.getAttribute('data-ok'); }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          })
          .catch(function (err) {
            if (msg) { msg.className = 'mt-pp__mensaje is-error'; msg.textContent = err.message; }
            boton.disabled = false;
            boton.textContent = original;
          });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeroSlides();
    initProducto();
  });
})();
